/**
 * Sleep for `durationMs` milliseconds.
 */
export default (durationMs: number) => new Promise(resolve => setTimeout(resolve, durationMs))
